import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { IPublicEnumPluginRegisterLevel } from '@alilc/lowcode-types';
import { Logger } from '@alilc/lowcode-utils';
import { BasicContext } from './context/base-context';
var logger = new Logger({
  level: 'warn',
  bizName: 'workspace:resource'
});
export var Resource = /*#__PURE__*/function () {
  function Resource(resourceData, resourceType, workspace) {
    var _this = this,
      _this$resourceData,
      _this$resourceData$ch;
    this.resourceData = resourceData;
    this.resourceType = resourceType;
    this.workspace = workspace;
    this.context = void 0;
    this.resourceTypeInstance = void 0;
    this.editorViewMap = new Map();
    this.children = void 0;
    this.context = new BasicContext(workspace, "resource-" + (resourceData.resourceName || resourceType.name), IPublicEnumPluginRegisterLevel.Resource);
    this.resourceTypeInstance = resourceType.resourceTypeModel(this.context.innerPlugins._getLowCodePluginContext({
      pluginName: ''
    }), this.options);
    this.init();
    if (this.resourceTypeInstance.editorViews) {
      this.resourceTypeInstance.editorViews.forEach(function (d) {
        _this.editorViewMap.set(d.viewName, d);
      });
    }
    if (!resourceType) {
      logger.error("resourceType[" + resourceType + "] is unValid.");
    }
    this.children = ((_this$resourceData = this.resourceData) === null || _this$resourceData === void 0 ? void 0 : (_this$resourceData$ch = _this$resourceData.children) === null || _this$resourceData$ch === void 0 ? void 0 : _this$resourceData$ch.map(function (d) {
      return new Resource(d, _this.workspace.getResourceType(d.resourceName || _this.resourceType.name), _this.workspace);
    })) || [];
  }
  var _proto = Resource.prototype;
  _proto.init = /*#__PURE__*/function () {
    var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$resourceTypeIns, _this$resourceTypeIns2;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (_this$resourceTypeIns = (_this$resourceTypeIns2 = this.resourceTypeInstance).init) === null || _this$resourceTypeIns === void 0 ? void 0 : _this$resourceTypeIns.call(_this$resourceTypeIns2);
          case 2:
            _context.next = 4;
            return this.context.innerPlugins.init();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function init() {
      return _init.apply(this, arguments);
    }
    return init;
  }();
  _proto["import"] = /*#__PURE__*/function () {
    var _import2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(schema) {
      var _this$resourceTypeIns3, _this$resourceTypeIns4;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (_this$resourceTypeIns3 = (_this$resourceTypeIns4 = this.resourceTypeInstance)["import"]) === null || _this$resourceTypeIns3 === void 0 ? void 0 : _this$resourceTypeIns3.call(_this$resourceTypeIns4, schema);
          case 2:
            return _context2.abrupt("return", _context2.sent);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function _import(_x) {
      return _import2.apply(this, arguments);
    }
    return _import;
  }();
  _proto.url = /*#__PURE__*/function () {
    var _url = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this$resourceTypeIns5, _this$resourceTypeIns6;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (_this$resourceTypeIns5 = (_this$resourceTypeIns6 = this.resourceTypeInstance).url) === null || _this$resourceTypeIns5 === void 0 ? void 0 : _this$resourceTypeIns5.call(_this$resourceTypeIns6);
          case 2:
            return _context3.abrupt("return", _context3.sent);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function url() {
      return _url.apply(this, arguments);
    }
    return url;
  }();
  _proto.save = /*#__PURE__*/function () {
    var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(value) {
      var _this$resourceTypeIns7, _this$resourceTypeIns8;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return (_this$resourceTypeIns7 = (_this$resourceTypeIns8 = this.resourceTypeInstance).save) === null || _this$resourceTypeIns7 === void 0 ? void 0 : _this$resourceTypeIns7.call(_this$resourceTypeIns8, value);
          case 2:
            return _context4.abrupt("return", _context4.sent);
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function save(_x2) {
      return _save.apply(this, arguments);
    }
    return save;
  }();
  _proto.getEditorView = function getEditorView(name) {
    return this.editorViewMap.get(name);
  };
  _createClass(Resource, [{
    key: "name",
    get: function get() {
      return this.resourceType.name;
    }
  }, {
    key: "viewName",
    get: function get() {
      return this.resourceData.viewName || this.resourceData.viewType || this.defaultViewName;
    }
  }, {
    key: "description",
    get: function get() {
      var _this$resourceTypeIns9;
      return (_this$resourceTypeIns9 = this.resourceTypeInstance) === null || _this$resourceTypeIns9 === void 0 ? void 0 : _this$resourceTypeIns9.description;
    }
  }, {
    key: "icon",
    get: function get() {
      var _this$resourceTypeIns10;
      return this.resourceData.icon || ((_this$resourceTypeIns10 = this.resourceTypeInstance) === null || _this$resourceTypeIns10 === void 0 ? void 0 : _this$resourceTypeIns10.icon);
    }
  }, {
    key: "type",
    get: function get() {
      return this.resourceType.type;
    }
  }, {
    key: "title",
    get: function get() {
      return this.resourceData.title || this.resourceTypeInstance.defaultTitle;
    }
  }, {
    key: "id",
    get: function get() {
      return this.resourceData.id;
    }
  }, {
    key: "options",
    get: function get() {
      return this.resourceData.options;
    }
  }, {
    key: "category",
    get: function get() {
      var _this$resourceData2;
      return (_this$resourceData2 = this.resourceData) === null || _this$resourceData2 === void 0 ? void 0 : _this$resourceData2.category;
    }
  }, {
    key: "skeleton",
    get: function get() {
      return this.context.innerSkeleton;
    }
  }, {
    key: "config",
    get: function get() {
      return this.resourceData.config;
    }
  }, {
    key: "editorViews",
    get: function get() {
      return this.resourceTypeInstance.editorViews;
    }
  }, {
    key: "defaultViewName",
    get: function get() {
      return this.resourceTypeInstance.defaultViewName || this.resourceTypeInstance.defaultViewType;
    }
  }]);
  return Resource;
}();